import { makeStyles } from '@material-ui/core';
import React from 'react';
import useWidth from 'v2/hooks/useWidth';

const useStyles = makeStyles((theme) => ({
  root: {
    background: 'transparent',
    borderRadius: '4px',
    minWidth: '100%',
    borderCollapse: 'separate',
    borderSpacing: '0 0.5rem',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      '&:not(.disable-responsive)': {
        display: 'block',
      },
    },
  },
}));

interface IProps {
  children: React.ReactNode;
  responsive: boolean;
}

const MyTable = ({ children, responsive }: IProps) => {
  const width = useWidth();
  const classes = useStyles({});

  if (width === 'md' || width === 'lg' || width === 'xl') {
    return (
      <table data-testid='mytable-table' className={classes.root + ' my-table -sales ' + (!responsive ? 'disable-responsive' : '')}>
        {children}
      </table>
    );
  }

  return <div data-testid='mytable-div'>{children}</div>;
};

export default MyTable;
